export default __webpack_public_path__ + "static/media/wmlWebsite2.fb19136b.jpg";